/// <amd-module name="DistributedTaskUI/Logs/AgentlessPhaseLogsDetailsView" />
import * as React from "react";

import { IServerPhaseJobItem } from "DistributedTaskUI/Logs/Logs.Types";
import { PhaseLogsDetailsView, IPhaseLogsDetailsViewProps } from "DistributedTaskUI/Logs/PhaseLogsDetailsView";
import { IPhaseSummaryViewProps } from "DistributedTaskUI/Logs/PhaseSummaryView";
import * as Resources from "DistributedTaskUI/Logs/Resources";


/**
 * Details view for the agent less phase
 */
export class AgentlessPhaseLogsDetailsView extends PhaseLogsDetailsView<IPhaseLogsDetailsViewProps> {

    protected _getPhaseSummaryProperties(): IPhaseSummaryViewProps | null {
        const serverPhaseJobItem = this.props.item as IServerPhaseJobItem;

        if (serverPhaseJobItem) {
            return {
                name: serverPhaseJobItem.name,
                startTime: serverPhaseJobItem.startTime,
                finishTime: serverPhaseJobItem.finishTime,
                logUrl: serverPhaseJobItem.logUrl,
                pageContext: this.props.pageContext,
                onRenderSecondaryDetailsLeftSection: this._onRenderSecondaryDetailsLeftSection
            };
        } else {
            return null;
        }
    }

    private _onRenderSecondaryDetailsLeftSection = (): JSX.Element  => { 
        return (
            <div>{Resources.PhaseRunOnServerText}</div>
        );
    }

    protected _containerClassName: string = "server-phase-logs-details-view";
}